import { render, staticRenderFns } from "./InputItems.vue?vue&type=template&id=5bcd7d42&scoped=true"
import script from "./InputItems.vue?vue&type=script&lang=js"
export * from "./InputItems.vue?vue&type=script&lang=js"
import style0 from "./InputItems.vue?vue&type=style&index=0&id=5bcd7d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcd7d42",
  null
  
)

export default component.exports